<template>
  <div id="app">
    <neon-header></neon-header>
    <main>
        <div class="index-main">
          Here is Index Page.
        </div>
    </main>
    <neon-footer></neon-footer>
  </div>
</template>

<script>
  import Header from '../common/Header'
  import Footer from '../common/Footer'

  export default {
    name: 'app',
    components: {
      'neon-header': Header,
      'neon-footer': Footer
    }
  }
</script>

<style scoped>
  .index-main{
    margin: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/index.vue